import React from 'react';
import logo from './logo.svg';
import './App.css';
import './assets/css/theme.scss';
import EventsManagement from './admin/EventsManagement'
import EventGrid from './admin/EventGrid'

function App() {

  return (

    <div className="App">
      <EventGrid />
    </div>
  );
}

export default App;
